<script setup lang="ts"></script>
<template>
    <div class="prose prose-stone dark:prose-invert">
        <h1>Terms & Conditions for using ASKr</h1>
        <p class="mt-0 text-sm text-stone-500 dark:text-stone-200">Last modified: 18th February 2025</p>
        <p>
            The ASKr platform is wholly owned by GREEN ROOM SPACE LTD, a company registered on 22nd September 2014 in
            England & Wales under number Company number 10837358 (“The Green Room” “we” “us”).
        </p>
        <p>
            By proceeding to use the ASKr platform you indicate that you accept these terms and conditions and that you
            agree to abide by them. These terms and conditions supersede any and all other T&Cs associated with your use
            of ASKr.
        </p>
        <h2>Overview</h2>
        <p>
            THE GREEN ROOM operates a software Platform, “ASKr” that allows Users to assemble groups of other Users and
            ask them questions in a private and secure, online environment.
        </p>
        <h2>User Charter</h2>
        <p>As a User of ASKr you agree to always behave in support of the following principles;</p>
        <ul>
            <li>
                Collaboration: Users can achieve great things when they collaborate in a constructive and encouraging
                manner, always offering the best of themselves and asking the best of each other.
            </li>
            <li>
                Laws, codes and industry norms: Users will always work to both the letter and spirit of any laws, codes
                or industry norms that exist in the areas they are operating in, at every opportunity seeking to enhance
                the reputation of ASKr Users.
            </li>
            <li>
                Integrity: Users will always bring honesty and integrity to any collaborative exercise in ASKr and will
                ask others they collaborate with to do the same.
            </li>
            <li>
                Confidentiality: Users always maintain confidentiality by default, only sharing information where they
                have permission to do so.
            </li>
        </ul>
        <p>
            THE GREEN ROOM reserves the absolute right to remove ASKr access rights, temporarily or permanently, from
            any individual it believes is acting in ways that are not aligned to the above principles.
        </p>
        <h2>User accounts</h2>
        <p>
            ASKr is open to adults (over 18 years old). To access ASKr, Users have to register for an account, provide
            accurate and complete information, and keep their account information updated. Each account must be an
            individual account with the User being an individual person. Companies cannot join as Users and any company
            accounts set up will be removed and any associated data may be destroyed. Users may be unemployed, in
            full-time education (over 18 years of age), an employee, a sole trader or a director of a limited company or
            any other legal entity (whether incorporated or unincorporated) but in all cases can only join ASKr as an
            individual. As a User you are personally responsible for abiding by these Terms and Conditions.
        </p>
        <p>
            The Green Room reserves the right to terminate your ASKr account, restrict your access to ASKr temporarily
            or indefinitely, or issue you a warning if in our opinion:
        </p>
        <ul>
            <li>you breach the letter or spirit of these terms and conditions or any referenced policies;</li>
            <li>we are unable to verify or authenticate any information you provide to us;</li>
            <li>we believe that your actions may cause any loss or liability to other ASKr Users or THE GREEN ROOM.</li>
        </ul>
        <p>
            Users are solely responsible for any activity that occurs on their account, unless it is a result of actions
            beyond their control (such as if someone steals their password when they have taken reasonable steps to keep
            it secure). By implication Users are responsible for the content on their accounts and should take the
            appropriate steps to ensure that any content they place on ASKr is their own or that they have the required
            permission to share it. THE GREEN ROOM will not be held liable for the consequences of any User sharing
            content they should not have shared. Users must never use another person's User account or registration
            information to access ASKr.
        </p>
        <h2>Albie</h2>
        <p>
            Albie is ASKr’s AI agent. Like all AI agents Albie’s responses may contain errors, hallucinations, or
            incomplete reasoning. Do not rely on Albie’s responses for high-stakes decisions. Green Room Space Ltd
            cannot vouch for the accuracy of responses generated by Albie and as such accepts no responsibility for any
            consequences that occur as a result of acting upon information contained within Albie’s responses.
        </p>
        <h2>Contacting</h2>
        <p>
            By accepting these terms, ASKr Users automatically opt-in to receive notifications from the ASKr platform,
            THE GREEN ROOM or any agents appointed by The Green Room to act on its behalf, in relation to activities
            they are undertaking within ASKr. THE GREEN ROOM takes privacy and data protection seriously and Users may
            opt out from receiving certain notifications from THE GREEN ROOM, its agents or the ASKr platform by
            emailing collaborate@The Green Room.space. Certain notifications are essential for the smooth operation of
            ASKr, for example task deadlines, new tasks, new replies etc., and for the duration of this contract Users
            cannot opt out of these types of notifications. If you have opted-out and, at a later time, wish to opt-in
            to any notifications, you can do this by emailing collaborate@The Green Room.space.
        </p>
        <h2>Non-disclosure</h2>
        <p>
            Users must consider all information shared with them, by THE GREEN ROOM, clients of THE GREEN ROOM, and
            other Users of the ASKr platform, as Confidential Information, unless otherwise stated, in writing. Should a
            User wish to share Confidential Information with anyone other than the person who provided the information,
            the User must obtain written permission from THE GREEN ROOM or the person or entity that provided the
            information, prior to sharing that information. THE GREEN ROOM will treat all information provided to it as
            confidential unless clearly marked otherwise in writing, at the point of sharing.
        </p>
        <h2>Termination</h2>
        <p>
            THE GREEN ROOM may terminate this agreement immediately if a User commits a material breach of any of these
            terms and conditions which, if capable of remedy, is not remedied within 7 days of being notified of the
            breach. In this instance THE GREEN ROOM may choose to remove the User from the ASKr Platform.
        </p>
        <h2>Privacy Policy</h2>
        <p>
            The ASKr platform is wholly owned by GREEN ROOM SPACE LTD, a company registered on 22nd September 2014 in
            England & Wales under number Company number 10837358 (“The Green Room”). By proceeding to use the ASKr
            platform, Users consent that THE GREEN ROOM may process the personal data (including sensitive personal
            data) that THE GREEN ROOM collects from them in accordance with the THE GREEN ROOM Privacy Policy and the
            terms of the UK Data Protection Act 2018.
        </p>
        <p>
            THE GREEN ROOM may use your personal data to gather feedback as part of set exercises you have agreed to
            take part in and also regarding your experience with THE GREEN ROOM and the ASKr platform. This helps our
            business improve by assembling useful information from our Users.
        </p>
        <p>
            THE GREEN ROOM will not share your email or phone number with anyone, except employees of THE GREEN ROOM
            working directly on projects you are involved with, without obtaining your permission in advance. THE GREEN
            ROOM may share all of the information within your profile, except for your email and phone number, with
            other Users in the same Groups you are part of within the ASKr software. Your data will not be shared with
            anyone who is not listed above. If you wish to view, change or request deletion of your data please contact
            collaborate@The Green Room.space.
        </p>
        <h2>Warrants</h2>
        <p>By accepting these terms, you warrant that:</p>
        <ul>
            <li>you will uphold THE GREEN ROOM’s terms and conditions for using ASKr.</li>
            <li>
                As a User of the ASKr platform you will always be responsible for any information, advice and content
                you provide and any liabilities associated with these always rest with you.
            </li>
            <li>
                in the use of the ASKr platform, you shall not (and shall not permit any third party to) take any action
                or upload, download, post, submit or otherwise distribute or facilitate distribution of, any content
                that infringes any patent, trademark, trade secret, copyright or other rights of any other person or
                entity or violates any law of England & Wales.
            </li>
            <li>
                in using ASKr in a professional capacity you will not contravene any policies set by your employer if
                you are employed.
            </li>
        </ul>
        <h2>Governing Law</h2>
        <p>
            These terms and conditions and any dispute or claim arising out of or in connection with them or their
            subject matter or formation (including non-contractual disputes or claims) shall be governed by and
            construed in accordance with the laws of England and Wales. The courts of England and Wales shall have
            exclusive jurisdiction to settle any dispute or claim that arises out of or in connection with these terms
            and conditions or their subject matter or formation (including non-contractual disputes or claims).
        </p>
    </div>
</template>
<style scoped></style>
